<table class="dropdown-list__table">
    <thead>
    <tr class="dropdown-list__table-row--header">
        <th class="dropdown-list__cell  dropdown-list__cell--first">
            {{ subtitle(5267) }}
        </th>
        <ng-container
                *ngFor="let connection of container.data.connections[chunk].pumpsConnection | orderByConnectionKey; let idx = index">
            <th class="dropdown-list__cell"
                [ngClass]="{ 'dropdown-list__cell--second': idx === 0  && chunk === 0,
				'dropdown-list__cell--last': idx === container.data.connections[chunk].pumpsConnection.length - 1 }">
                {{ connection.key === '0' ? 'M' : connection.key }}
            </th>
        </ng-container>
    </tr>
    </thead>
    <tbody>
    <tr class="dropdown-list__table-row">
        <td class="dropdown-list__cell dropdown-list__cell--first">
            {{ subtitle(3089) }}
        </td>
        <ng-container
            *ngFor="let connection of container.data.connections[chunk].pumpsConnection | orderByConnectionKey; let idx = index">
            <td class="dropdown-list__cell"
                [ngClass]="{ 'dropdown-list__cell--second': idx === 0  && chunk === 0,
				'dropdown-list__cell--last': idx === container.data.connections[chunk].pumpsConnection.length - 1}">
                <div class="dropdown-list__cell-connection"
                     [ngClass]="{'dropdown-list__cell-connection--set': connection.value}">
                </div>
            </td>
        </ng-container>
    </tr>
    <tr class="dropdown-list__table-row">
        <td class="dropdown-list__cell dropdown-list__cell--first">
            {{subtitle(1736)}}
        </td>
        <ng-container
            *ngFor="let connection of container.data.connections[chunk].freeContactConnection | orderByConnectionKey; let idx = index">
        <td class="dropdown-list__cell"
            [ngClass]="{ 'dropdown-list__cell--second': idx === 0  && chunk === 0,
				'dropdown-list__cell--last': idx === container.data.connections[chunk].freeContactConnection.length - 1}">
            <div class="dropdown-list__cell-connection"
                [ngClass]="{ 'dropdown-list__cell-connection--set': connection.value }">
            </div>
        </td>
        </ng-container>
    </tr>
    <tr class="dropdown-list__table-row">
        <td class="dropdown-list__cell dropdown-list__cell--first">
            {{subtitle(2459)}}
        </td>
        <ng-container
            *ngFor="let connection of container.data.connections[chunk].hcConnection | orderByConnectionKey; let idx = index">
            <td class="dropdown-list__cell"
                [ngClass]="{ 'dropdown-list__cell--second': idx === 0  && chunk === 0,
                    'dropdown-list__cell--last': idx === container.data.connections[chunk].hcConnection.length - 1 }">
                <div class="dropdown-list__cell-connection"
                     [ngClass]="{ 'dropdown-list__cell-connection--set': connection.value }">
                </div>
            </td>
        </ng-container>
    </tr>
    <tr class="dropdown-list__table-row"
        *ngIf="container.data.parameters.hasOwnProperty('ecoInputConnection')">
        <td class="dropdown-list__cell dropdown-list__cell--first">
            {{ subtitle(12740) }}
        </td>
        <ng-container
            *ngFor="let connection of container.data.connections[chunk].ecoInputConnection | orderByConnectionKey; let idx = index">
        <td class="dropdown-list__cell"
            [ngClass]="{ 'dropdown-list__cell--second': idx === 0  && chunk === 0,
				'dropdown-list__cell--last': idx === container.data.connections[chunk].ecoInputConnection.length - 1 }">
            <div class="dropdown-list__cell-connection"
                [ngClass]="{ 'dropdown-list__cell-connection--set': connection.value }">
            </div>
        </td>
        </ng-container>
    </tr>
    </tbody>
</table>
